import React from 'react';
import { TextField, TextFieldProps, Tooltip, TooltipProps } from '@material-ui/core';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

// NumberFormat v4.6.1 is inferring types on `TextField` forcing us to explicitely omit types
type SanitizedNumberFormatProps = Omit<NumberFormatProps, 'size' | 'number' | 'color'>;

export type NumberMaskedFieldProps = TextFieldProps & {
  MaskedProps?: SanitizedNumberFormatProps;
  'data-testid'?: string;
  toolTipProps?: TooltipProps & { isVisible?: boolean };
};

export const NumberMaskedField = ({ value: valueProp, MaskedProps, ...props }: NumberMaskedFieldProps): JSX.Element => {
  // input value cannot be null coerce to string to ensure update of component when clearing field using nulls
  const value = typeof valueProp === 'string' || typeof valueProp === 'number' ? valueProp : '';

  const input = (
    <NumberFormat
      value={value ?? ''}
      {...MaskedProps}
      {...(props as SanitizedNumberFormatProps)}
      customInput={TextField}
    />
  );

  return props?.toolTipProps?.isVisible ? <Tooltip {...props.toolTipProps}>{input}</Tooltip> : input;
};

export default NumberMaskedField;
